import React, { useState, useRef, useEffect } from 'react';
import { BsListUl } from 'react-icons/bs';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import './ChatPanel.css';

function ChatPanel({
  conversations,
  activeConversationId,
  onSelectConversation,
  onSendMessage,
  onClose,
}) {
  const [showPastChatsView, setShowPastChatsView] = useState(false);
  const messagesScrollRef = useRef(null);
  const activeConversation = conversations.find(function (c) {
    return c.id === activeConversationId;
  });
  const messages = activeConversation ? activeConversation.messages : [];

  useEffect(
    function () {
      if (messagesScrollRef.current && !showPastChatsView) {
        messagesScrollRef.current.scrollTop = messagesScrollRef.current.scrollHeight;
      }
    },
    [messages.length, showPastChatsView]
  );

  function handleSelectConversation(id) {
    if (onSelectConversation) onSelectConversation(id);
    setShowPastChatsView(false);
  }

  return (
    <div className="chat-panel">
      <div className="chat-panel-header">
        <button
          type="button"
          className="chat-panel-past-chats-icon"
          onClick={function () {
            setShowPastChatsView(true);
          }}
          aria-label="View past chats"
          title="Past chats"
        >
          <BsListUl size={20} />
        </button>
        <div className="chat-panel-avatar">C2W</div>
        <div className="chat-panel-title-wrap">
          <h2 className="chat-panel-title">Clarity2Work Agent</h2>
          <p className="chat-panel-subtitle">Your intelligent assistant</p>
        </div>
        {onClose && (
          <button
            type="button"
            className="chat-panel-close"
            onClick={onClose}
            aria-label="Close chat"
            title="Close chat"
          >
            ×
          </button>
        )}
      </div>

      <div className="chat-panel-body">
        {showPastChatsView ? (
          <div className="chat-panel-past-chats-view">
            <div className="chat-panel-past-chats-view-header">
              <h3 className="chat-panel-past-chats-view-title">Past Chats</h3>
              <button
                type="button"
                className="chat-panel-past-chats-view-close"
                onClick={function () {
                  setShowPastChatsView(false);
                }}
                aria-label="Close past chats"
                title="Close"
              >
                ×
              </button>
            </div>
            <div className="chat-panel-past-chats-view-list">
              {conversations.map(function (conv) {
                const isActive = conv.id === activeConversationId;
                return (
                  <button
                    key={conv.id}
                    type="button"
                    className={'chat-panel-past-chats-view-item' + (isActive ? ' chat-panel-past-chats-view-item--active' : '')}
                    onClick={function () {
                      handleSelectConversation(conv.id);
                    }}
                  >
                    {conv.title}
                  </button>
                );
              })}
            </div>
          </div>
        ) : (
          <>
            <div
              className="chat-panel-messages"
              ref={messagesScrollRef}
              role="region"
              aria-label="Messages"
            >
              <ChatMessages messages={messages} />
            </div>
            <div className="chat-panel-input">
              <ChatInput onSend={onSendMessage} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ChatPanel;
